import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const myCase = {
  vars: {},
  client: {},
  terms: {},
  loaded: false
}

export default new Vuex.Store({
  state: {
    loaded: false,
    loading: {
      message: 'Loading application...',
      spin: true,
      buttons: []
    },
    mycase: JSON.parse(localStorage.getItem('mycase')) || myCase,
    uploads: JSON.parse(localStorage.getItem('uploads')) || {},
    lang: localStorage.getItem('lang') || 'en',
    isFooterBarVisible: true,
    status: '',
    endpoint: (process.env.NODE_ENV === 'production' ? 'https://mr.xtramuros.com/php/routes/' : 'http://localhost:8000')
  },
  mutations: {
    /* A fit-them-all commit */
    basic (state, payload) {
      state[payload.key] = payload.value
    },
    case_error (state) {
      state.loaded = true
      state.status = 'error'
    },
    case_success (state, data) {
      data.loaded = true
      if (data.vars && data.vars.lang) {
        state.lang = data.vars.lang
        localStorage.setItem('lang', state.lang)
      }
      state.mycase = Object.assign({}, state.mycase, data)
      localStorage.setItem('mycase', JSON.stringify(data))
    },
    lang_error (state) {
      state.status = 'error'
    },
    lang_success (state, data) {
      let mycase = state.mycase
      mycase.terms = data.terms
      state.lang = data.lang
      state.mycase = Object.assign({}, state.mycase, mycase)
      localStorage.setItem('mycase', JSON.stringify(mycase))
      localStorage.setItem('lang', state.lang)
    },
    upload_success (state, data) {
      state.uploads = Object.assign({}, state.uploads, data)
      localStorage.setItem('uploads', JSON.stringify(data))
    },
    upload_remove (state, data) {
      if (state.uploads[data.type] && state.uploads[data.type].files) {
        state.uploads[data.type].files = state.uploads[data.type].files.filter(e => {
          return e.path !== data.path
        })
        localStorage.setItem('uploads', JSON.stringify(state.uploads))
      }
    }
  },
  getters: {
    status (state) {
      return state.status
    }
  },
  actions: {
    caseStart ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post('/case_start.php', { data: data }).then((res) => {
          commit('case_success', res.data)
          resolve(res.data)
        }).catch(err => {
          commit('case_error')
          reject(err)
        })
      })
    },
    lang ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post('/lang.php', { data: data }).then((res) => {
          commit('lang_success', res.data)
          resolve(res.data)
        }).catch(err => {
          commit('lang_error')
          reject(err)
        })
      })
    },
    upload ({ commit }, data) {
      return new Promise((resolve, reject) => {
        const type = data.type
        let uploads = this.state.uploads
        delete data.type
        if (uploads[type]) {
          delete uploads[type]
        }
        uploads[type] = data
        commit('upload_success', uploads)
        resolve(uploads)
      })
    },
    uploadMulti ({ commit }, data) {
      return new Promise((resolve, reject) => {
        const type = data.type
        let uploads = this.state.uploads
        delete data.type
        if (uploads[type]) {
          data.files.forEach(e => {
            uploads[type].files.push(e)
          })
        } else {
          uploads[type] = data
        }
        commit('upload_success', uploads)
        resolve(uploads)
      })
    },
    remove ({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit('upload_remove', data)
        resolve(this.state.uploads)
      })
    },
    showLoader ({ commit }, data) {
      this.state.loaded = false
      this.state.loading.buttons = []
      this.state.loading.spin = true
      this.state.loading.message = data.message
    },
    hideLoader () {
      this.state.loaded = true
      this.state.loading.message = Object.assign({}, this.state.loading, { message: '' })
    }
  }
})
